import { GetServerDataReturn, HeadProps, PageProps, graphql, navigate } from 'gatsby'
import React from 'react'
import { AppHead } from '../../components/common'
import { Firm } from '../../components/firms/firm/mapper'
import { firmRequest } from '../../components/firms/firmQueries/firmRequests'
import FirmTemplate from '../../components/firms/firmTemplate'

interface ServerRequestProps {
  firm: Firm | null
}

const FirmPage: React.FC<PageProps<Queries.constantsQuery>> = ({
  data,
  serverData = { firm: null },
  location,
}) => {
  const constants = {
    siteStrapiUrl: data.site?.siteMetadata?.siteStrapiUrl || '',
    frontStrapiToken: data.site?.siteMetadata?.frontStrapiToken || '',
    googleMapsApiKey: data.site?.siteMetadata?.googleMaps?.apiKey || '',
    recaptchaKey: data.site?.siteMetadata?.recaptchaKey || '',
    youTubeApiKey: data.site?.siteMetadata?.youTubeApiKey || '',
  }
  const { firm } = serverData as ServerRequestProps

  if (!firm || !constants.siteStrapiUrl || !constants.frontStrapiToken) {
    if (typeof window !== 'undefined') {
      navigate('/404')
    }
    return null
  }

  return (
    <FirmTemplate
      data={firm}
      constants={constants}
      isCareerSite={false}
      location={location}
    />
  )
}

export async function getServerData({
  params,
}: {
  params: { slug: string }
}): GetServerDataReturn<ServerRequestProps> {
  try {
    const backEndUrl = process.env.CORE_STRAPI_URL
    const token = process.env.CORE_STRAPI_READ_TOKEN

    if (!backEndUrl) {
      throw new Error(`Strapi url is not defined GroupPage`)
    }

    if (!token) {
      throw new Error(`Strapi token is not defined GroupPage`)
    }

    const { slug } = params

    if (!slug) {
      throw new Error(`Slug is not defined OfferPage`)
    }

    const response = await firmRequest(
      slug.toLowerCase(),
      backEndUrl,
      token,
    )

    return {
      status: response ? 200 : 404,
      props: {
        firm: response,
      },
    }
  } catch (error) {
    console.error(error, 'error')
    return {
      status: 500,
      headers: {},
      props: {
        firm: null,
      },
    }
  }
}

export const Head: React.FC<HeadProps<Queries.FirmQuery>> = ({ data, serverData = { firm: null } }) => {
  const { firm } = serverData as ServerRequestProps
  const firmName =
    firm?.name || window.location.pathname.split('/')[2]
  const linkCanonical = firm?.slug
    ? `${data.site?.siteMetadata?.siteUrl}/cabinets/${firm?.slug}`
    : null
  const metaImage =
    (firm?.header?.url || firm?.headerUrl) || '/lamacompta-sharing-default.jpg'
  return (
    <AppHead
      title={`${firmName} cabinet d'expertise comptable recrute !`}
      metaDescription={`Consultez les Dernières Offres d'Emploi de ${firmName} sur Lamacompta.  Postulez en ligne - Découvrez le cabinet d'expertise comptable ${firmName}, ses valeurs et son équipe !`}
      metaTitle={`${firmName} cabinet d'expertise comptable recrute !`}
      linkCanonical={linkCanonical}
      metaImage={metaImage}
    />
  )
}

export default FirmPage

export const query = graphql`
  query constants {
    site {
      siteMetadata {
        siteStrapiUrl
        siteUrl
        frontStrapiToken
        recaptchaKey
        youTubeApiKey
        googleMaps {
          apiKey
        }
      }
    }
  }
`
